let env = process.env;

export default {
  ACCOUNT_KEY: env.ACCOUNT_KEY,
  THEME : 'normal',
  BOT_ID: env.BOT_ID,
  BOT_DEP_ID : env.BOT_DEP_ID

};



// WEBPACK FOOTER //
// ./src/config/base.js